---
title: "Troubleshooting Chosen"
description: "Something in Chosen not working? Start here. A symptom index for resume parsing, interview scheduling, sourcing outreach, and integration problems."
category: "troubleshooting"
keywords:
  - "Chosen troubleshooting"
  - "Chosen ATS not working"
  - "fix Chosen problem"
  - "Chosen support"
schema: "HowTo"
nav:
  section: "troubleshooting"
  order: 10
---

Something isn't working. That's annoying, and most of the time it's fixable in a minute or two. This page points you at the right fix — find the symptom that matches, follow the link.

Most problems in Chosen come down to one of a few things: a connected integration quietly went stale, an AI step is waiting on data it doesn't have yet, or a setting is tighter than you remember. The pages below cover each.

## Find your symptom

- **[A resume didn't parse, or parsed badly](/troubleshooting/resume-parsing-failed)** — a candidate's fields came back empty, half-filled, or wrong after a resume upload.
- **[An interview won't auto-schedule](/troubleshooting/scheduling-not-working)** — the AI scheduler offered no times, or scheduling seems stuck with nothing happening.
- **[A sourcing outreach email didn't send](/troubleshooting/outreach-not-sending)** — you hit send on a prospect message and it never went out.
- **[Gmail, Calendar, or Notion stopped working](/troubleshooting/integration-issues)** — an integration shows disconnected, or features that depend on one went quiet.

## Still stuck?

If none of the above fixes it, the problem is worth a closer look. Open **Settings → Contact support** and tell us what you did, what you expected, and what happened instead. The more specific you are, the faster this goes.
